import { type IconDefinition, faClock, faCrosshairs, faDoorClosed } from '@fortawesome/pro-regular-svg-icons';
import { CodeTag } from '@tryhackme/thm-ui-components';
import { StyledTagContainer } from './monthly-user-metrics.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { MonthlyUserMetricsProps } from './monthly-user-metrics.types';
export const MonthlyUserMetrics = ({
  metrics
}: MonthlyUserMetricsProps) => {
  const {
    completedRooms,
    questionsAnswered,
    uniqueLearningDays
  } = metrics;
  return <StyledTagContainer data-sentry-element="StyledTagContainer" data-sentry-component="MonthlyUserMetrics" data-sentry-source-file="monthly-user-metrics.tsx">
      <MetricTag label={'rooms completed'} value={completedRooms} icon={faDoorClosed} data-sentry-element="MetricTag" data-sentry-source-file="monthly-user-metrics.tsx" />
      <MetricTag label={'questions answered'} value={questionsAnswered} icon={faCrosshairs} data-sentry-element="MetricTag" data-sentry-source-file="monthly-user-metrics.tsx" />
      <MetricTag label={'days spent on TryHackMe'} value={uniqueLearningDays} icon={faClock} data-sentry-element="MetricTag" data-sentry-source-file="monthly-user-metrics.tsx" />
    </StyledTagContainer>;
};
interface MetricTagProps {
  readonly label: string;
  readonly value: number | null;
  readonly icon: IconDefinition;
}
const MetricTag = ({
  label,
  value,
  icon
}: MetricTagProps) => {
  if (!value) return null;
  return <CodeTag data-sentry-element="CodeTag" data-sentry-component="MetricTag" data-sentry-source-file="monthly-user-metrics.tsx">
      <FontAwesomeIcon icon={icon} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="monthly-user-metrics.tsx" /> {value.toLocaleString('en-US')} {label}
    </CodeTag>;
};